import { render } from "./ribbon-controls.vue?vue&type=template&id=7983890c&scoped=true"
import script from "./ribbon-controls.vue?vue&type=script&lang=js"
export * from "./ribbon-controls.vue?vue&type=script&lang=js"

import "./ribbon-controls.vue?vue&type=style&index=0&id=7983890c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7983890c"]])

export default __exports__